/**
 * 加载图片
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React, { useCallback, useEffect, useMemo, useState, useContext } from "react";

import "./index.less";
import { ChatMessage, ChatMessageType, SessionType } from "@/types/chat";
import { MessageSendType } from "@/types/chat/enum";
import { useTranslation } from "react-i18next";
import { isEqualEmployee, mySendMessage } from "@/utils/chat/message";
import { connect } from "dva";
import ChatState from "@/types/chat/State";
import ChatEvent from "@/components/chat/view/ChatEvent";
import GlobalContext from "@/context/GlobalContext";

interface RevokeProps {
  message: ChatMessage & { revokeTime: number };
  sessionType?: SessionType;
  sendType?: MessageSendType;
  plulistindex: [];
}

type IRevokeProps = Readonly<RevokeProps & ChatState>;

function Revoke(props: IRevokeProps) {
  const { message, currentEmployee, sessionType, plulistindex } = props;
  const { t } = useTranslation("chat");
  const [canReedit, setCanReedit] = useState(false);
  const { appRuntimeEnv } = useContext(GlobalContext);
  const { im } = appRuntimeEnv;
  // const canReedit = useMemo(() => {
  //     const times = 5 * 60 * 1000;
  //     if (Date.now() > message.timestamp + times) {
  //         return false;
  //     }
  //     return mySendMessage({ message, currentEmployee }) && message.type === ChatMessageType.TEXT;
  // }, [message, currentEmployee]);

  const reeditMessage = useCallback(() => {
    if (canReedit) {
      ChatEvent.emit("reedit-message", { message });
    }
  }, [canReedit, message]);

  const revokeTextTip = useMemo(() => {
    let Msg: any = message;
    const isEqualuser = isEqualEmployee(Msg?.sender, Msg?.revoker);
    if (mySendMessage({ message, currentEmployee }) && Msg.plusList && plulistindex) {
      return `您撤回了${plulistindex.length}条消息`;
    }
    if (mySendMessage({ message, currentEmployee }) && (!Msg.revoker || isEqualuser)) {
      return t("you_revoke_message");
    } else {
      if (sessionType === SessionType.SINGLE || sessionType === SessionType.SECRET_SINGLE) {
        return t("other_revoke_message");
      } else if (sessionType === SessionType.GROUP) {
        if (Msg?.revoker && !isEqualuser) {
          if (isEqualEmployee(currentEmployee, Msg?.revoker)) {
            return t("admin revoke message", { operator: "您", sender: message?.sender.name });
          } else if (isEqualEmployee(currentEmployee, Msg?.sender)) {
            return `${t("admin revoke message", {
              operator: Msg?.revoker?.name,
              sender: "您"
            })}，不支持重新编辑`;
          } else {
            return t("admin revoke message", {
              operator: Msg?.revoker?.name,
              sender: Msg?.sender.name
            });
          }
        } else {
          return t("someone-revoke-message", { name: message?.sender.name });
        }
      }
    }
  }, [t, message, currentEmployee, sessionType, plulistindex]);

  useEffect(() => {
    // 消息撤回后 能够重新编辑的时间
    // console.log('im.chatReeditTime' + im.chatReeditTime);
    const times = im.chatReeditTime || 300000;
    const revokeTime = message?.revokeTime || message.timestamp;
    let Msg: any = message;
    if (!mySendMessage({ message, currentEmployee })) {
      return;
    }
    if (Msg?.revoker && !isEqualEmployee(currentEmployee, Msg?.revoker)) {
      return;
    }
    if (message.type !== ChatMessageType.TEXT) {
      setCanReedit(false);
      return;
    }
    if (Date.now() > revokeTime + times) {
      setCanReedit(false);
      return;
    } else {
      setCanReedit(true);
      const ms = times - (Date.now() - revokeTime);
      // 超过5秒定时
      if (ms > 5000) {
        const timeout = setTimeout(() => {
          setCanReedit(false);
          clearTimeout(timeout);
        }, ms);
      } else {
        // 不足5秒， 直接设置 不让重新编辑
        setCanReedit(false);
      }
    }
  }, [message, currentEmployee, im.chatReeditTime]);

  return (
    <div className="content" id={message.id}>
      <div className="revoke-message">
        <div className="revoke-message-text">
          {revokeTextTip}
          {canReedit && (
            <span>
              &nbsp;<a onClick={reeditMessage}>{t("revoke_reedit")}</a>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  const { currentEmployee, sessionMessageMap } = chat as ChatState;
  return { currentEmployee, sessionMessageMap };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Revoke);

// export default withTranslation('chat')();
